import {BaseContainerModel} from '../base-container.model';
import {bl_fi_ocr_scanned_doc_report_export_file_hdr_RowClass} from '../../dbschema';

export class OcrScannedDocReportExportContainerModel extends BaseContainerModel {
    bl_fi_ocr_scanned_doc_report_export_file_hdr: bl_fi_ocr_scanned_doc_report_export_file_hdr_RowClass = new bl_fi_ocr_scanned_doc_report_export_file_hdr_RowClass();
}
